import { css } from '@emotion/react'

export default (theme) => css`
  :root {
    --text-base-size: 1em;
    --font-primary: 'Prompt', sans-serif;
    --font-color: ${theme.common.textColor};

    --body-line-height: 1.4;
    --heading-line-height: 1.2;
  }

  body {
    font-size: var(--text-base-size);
    font-family: var(--font-primary);
    color: var(--font-color);
  }

  h1,
  h2,
  h3,
  h4 {
    color: var(--font-color);
    line-height: var(--heading-line-height);
    font-weight: 700;
    margin: 0;
  }

  h2 {
    font-weight: 600;
    font-size: 30px;
    line-height: 36px;
  }

  h3 {
    font-weight: 500;
    font-size: 24px;
    line-height: 30px;
  }

  a {
    color: var(--color-primary);
    text-decoration: none;

    &:hover {
      color: var(--color-primary-dark);
      text-decoration: underline;
    }
  }

  mark {
    background-color: alpha(var(--color-accent), 0.2);
    color: inherit;
  }

  strong {
    font-weight: 700;
  }

  s {
    text-decoration: line-through;
  }

  u {
    text-decoration: underline;
  }
`
